import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@mui/material';
// import { ScheduleTooltip } from 'components/ScheduleDetail';
import cn from 'classnames';
import ScheduleTooltip from '../../components/ScheduleDetail/ScheduleTooltip';
import { openEventDetail } from '../../store/slices/scheduleSlice';
import { useDispatch } from 'react-redux';

export const Event = ({
  EventComponent,
  event,
  key,
  style,
  label,
  title,
  handleClick,
  className,
  isSelected,
  lastLeftOffset,
}) => {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };
  const dispatch = useDispatch();
  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      key={key}
      style={style}
      title={`${label}: ${title}`}
      onClick={()=>{
        dispatch(openEventDetail(event));
      }}
      className={cn('rbc-event', className, {
        'rbc-selected': isSelected,
        'rbc-event-overlaps': lastLeftOffset !== 0,
      })}
    >
      {/* <ScheduleTooltip open={hovered} start={event.start} end={event.end} /> */}
      <div className="rbc-event-label">{label}</div>
      <div className="rbc-event-content">
        {EventComponent ? (
          <EventComponent event={event} title={title} />
        ) : (
          title
        )}
      </div>
      <Divider className="event-bottom-divider" />
      <Divider className="event-left-divider" />
    </div>
  );
};

Event.propTypes = {
  EventComponent: PropTypes.elementType,
  event: PropTypes.object,
  key: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.string,
  title: PropTypes.string,
  handleClick: PropTypes.func,
  className: PropTypes.string,
  isSelected: PropTypes.bool,
  lastLeftOffset: PropTypes.number,
};

export default Event;